export default __webpack_public_path__ + "static/pexels-christina-morillo-1181395-ddba70cbeca78f047ed160601cfac8e6.jpg";